/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import LabelAssignmentField from 'material/embeds/labelassignmentfield/labelassignmentfield_container'
import {Copy, Form, SubPage, Title, Divider, Accent} from "@insticator/insticator-ui";

// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/editlabels/editlabels_styles';




/* ========== ~~~~~~~~~~ EDIT LABELS ~~~~~~~~~~ ========== */
const EditLabels = (props) => {
    let labelUUIDs = [];
    let embedName = '';

    const getReconciledLabels = (labelUUIDs) => {
        /*
            When the user removes the label from the dropdown manager we do not make the call to fetch all embeds again.
            Deleted item uuid will still be attached to the embed in the application state.
            This method ensures the ghost uuid is removed from the embed.
         */
        let ghostItemDetected = false;
        const filteredCollection = labelUUIDs.filter(labelUUID => {
            const itemExists = Object.keys(props.labels).includes(labelUUID);
            ghostItemDetected = itemExists ? ghostItemDetected : itemExists;
            return itemExists;
        });
        if(ghostItemDetected) {
            this.setEmbedCardLabels(filteredCollection)
        }
        return [...filteredCollection]
    };


    props.clientEmbeds.forEach(embed => {
        if (embed.embedUUID === props.embedUUID) {
            labelUUIDs = getReconciledLabels(embed.labelUUIDs);
            embedName = embed.embedName;
        }
    });

    const attachLabel = (labelUUID) => saveLabelsUpdate([...labelUUIDs, labelUUID]);

    const removeLabel = (labelUUID) => saveLabelsUpdate([...(labelUUIDs.filter(attachedLabelUUID => attachedLabelUUID !== labelUUID))])

    const saveLabelsUpdate = (labelUUIDs) =>
        props.attachLabelToEmbed(props.accountUUID, props.embedUUID, labelUUIDs);

    return(
        <SubPage name={`editlabels`} klass={props.classes.editlabels}>
            <Copy name={`title`}>
                <Title size={`medium`}>
                    <h2>{`Labels`}</h2>
                </Title>
            </Copy>
            <LabelAssignmentField attachedLabelUUIDs={labelUUIDs}
                                  attachLabel={attachLabel}
                                  removeLabel={removeLabel}
            />
            <Divider />
            <Accent>
                <span className={'accentitem'}>Attach or remove labels from your<strong>{` "${embedName}" `}</strong>embed.</span>
                <span className={'accentitem'}>{`All changes will be applied instantly.`}</span>
            </Accent>
        </SubPage>);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EditLabels);
